import React from 'react'
import { Tag, Text, Box } from '@chakra-ui/core'

import LocaleText from 'components/LocaleText'
import { UserSummary } from './UserSummary'
import { HoverPopover } from '../HoverPopover'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'

interface UserPopoverProps {
  children: React.ReactNode // Avatars component
  label?: string // Optional label text (e.g., 'watchers', 'auditors')
  userIds: string[]
  bg?: string
  icon?: React.ReactNode
  border?: string
  textColor?: string
  fontSize?: string
  fontWeight?: string
  px?: string
  py?: string
}

export const UserPopover: React.FC<UserPopoverProps> = ({
  children,
  label,
  userIds,
  bg = 'transparent',
  border = 'none',
  textColor = 'black',
  fontSize = '14px',
  fontWeight = '500',
  px = '0px',
  py = '5px',
}) => {
  const isRtl = useSelector(isRtlSelector)
  if (!userIds || userIds.length === 0) {
    return null
  }

  return (
    <HoverPopover
      placement={isRtl ? 'top-start' : 'top-end'}
      usePortal
      minWidth="0"
      maxWidth="400px"
      zIndex={100000}
      trigger={
        <Tag
          bg={bg}
          border={border}
          py={py}
          px={px}
          borderRadius="10px"
          w="fit-content"
          style={{ columnGap: '6px' }}
          cursor="pointer"
        >
          <Box pointerEvents="none">{children}</Box>

          <Text fontSize={fontSize} fontWeight={fontWeight} color={textColor} dir="ltr" whiteSpace="nowrap">
            <LocaleText text={label || ''} />
          </Text>
        </Tag>
      }
    >
      {userIds.map((uid) => (
        <UserSummary key={uid} uid={uid} />
      ))}
    </HoverPopover>
  )
}
